import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import cx from "classnames";
import { memo, useState } from "react";
import ConditionalWrapper from "../../atoms/ConditionalWrapper";
import Text from "../../atoms/Text";
import Accordion from "../Accordion";
/* -------------------------------------------------------------------------------------------------
 * Title (both top- and second level)
 * -----------------------------------------------------------------------------------------------*/
const HeaderAccordionTitle = memo(({ highlightLabel, title, size }) => (_jsxs(Text, { className: cx({
        "flex items-start gap-1": highlightLabel,
    }), size: size, tag: "span", children: [title, highlightLabel && (_jsx(Text, { gradient: true, size: "2xs", tag: "span", children: highlightLabel }))] })));
/* -------------------------------------------------------------------------------------------------
 * Top Level Item
 * -----------------------------------------------------------------------------------------------*/
const HeaderAccordionTopLevelItem = memo(({ collapsible, title, highlightLabel, renderLink, onClick }) => {
    if (!title)
        return null;
    return (_jsx(_Fragment, { children: _jsx(ConditionalWrapper, { condition: !collapsible, wrapper: (children) => (_jsx("div", { onClick: onClick, children: renderLink ? renderLink(children) : children })), children: _jsx(HeaderAccordionTitle, { size: "2xl", highlightLabel: highlightLabel, title: title }) }) }));
});
/* -------------------------------------------------------------------------------------------------
 * Second Level Item
 * -----------------------------------------------------------------------------------------------*/
const HeaderAccordionSecondLevelItem = memo(({ dropdown, onClick }) => {
    if (!dropdown)
        return null;
    return (_jsx(_Fragment, { children: dropdown.menuContent.map(({ title, description, highlightLabel, renderLink }) => {
            const linkChildren = (_jsxs("div", { className: "grid", children: [_jsx(HeaderAccordionTitle, { size: "lg", highlightLabel: highlightLabel, title: title }), _jsx(Text, { className: "w-full", size: "sm", variant: "muted", tag: "span", children: description })] }));
            return (_jsx("span", { onClick: onClick, children: renderLink ? renderLink(linkChildren) : linkChildren }, title));
        }) }));
});
/* -------------------------------------------------------------------------------------------------
 * Main Accordion
 * -----------------------------------------------------------------------------------------------*/
const HeaderAccordion = ({ navigationItems, offCanvasState }) => {
    const [value, setValue] = useState("");
    const handleClose = () => {
        offCanvasState.setIsOpen(false);
        setValue(""); // Resets accordions
    };
    if (navigationItems) {
        return (_jsx(Accordion, { collapsible: true, items: navigationItems.map((item) => ({
                title: (_jsx(HeaderAccordionTopLevelItem, { ...item, collapsible: Boolean(item.dropdown), highlightLabel: item.highlightLabel, onClick: () => {
                        handleClose();
                    }, title: item.title ?? item.dropdown?.menuTitle })),
                content: (_jsx(HeaderAccordionSecondLevelItem, { dropdown: item.dropdown, onClick: handleClose })),
                collapsible: Boolean(item.dropdown),
                id: item.title ?? item.dropdown?.menuTitle ?? "",
            })), onValueChange: (v) => setValue(v), type: "single", value: value }));
    }
    return null;
};
export default HeaderAccordion;
//# sourceMappingURL=HeaderAccordion.js.map